import React, { useState } from 'react';
import { supabase } from '../../services/supabaseClient';

interface Props {
  userId: string;
  onUpload: (url: string) => void;
  onUploadingChange: (uploading: boolean) => void;
}

const ArticleImageUpload: React.FC<Props> = ({ userId, onUpload, onUploadingChange }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const upload = async (file: File) => {
    setError('');
    const extensions: Record<string, string> = {
      'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/avif': 'avif',
    };
    const extension = extensions[file.type];
    if (!extension || !file.size || file.size > 10 * 1024 * 1024) {
      setError('Choose a JPG, PNG, WebP, or AVIF image under 10 MB.');
      return;
    }
    setUploading(true);
    onUploadingChange(true);
    try {
      const path = `${userId}/${crypto.randomUUID()}.${extension}`;
      const { error: uploadError } = await supabase.storage.from('article_images').upload(path, file, {
        contentType: file.type, cacheControl: '31536000', upsert: false,
      });
      if (uploadError) throw uploadError;
      const { data } = supabase.storage.from('article_images').getPublicUrl(path);
      onUpload(data.publicUrl);
    } catch {
      setError('Unable to upload this image. Please try again.');
    } finally {
      setUploading(false);
      onUploadingChange(false);
    }
  };

  return <div className="article-image-upload">
    <label htmlFor="article-image-file">{uploading ? 'Uploading image…' : 'Upload image'}</label>
    <input id="article-image-file" type="file" accept="image/jpeg,image/png,image/webp,image/avif" disabled={uploading}
      onChange={event => {
        const file = event.target.files?.[0];
        event.target.value = '';
        if (file) upload(file);
      }} />
    {error && <p role="alert">{error}</p>}
  </div>;
};
export default ArticleImageUpload;
